import type { Xinglet } from '@xing-com/crate-xinglet';

import { Logout } from './logout';

export default class LogoutXinglet implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <Logout />;
  }
}
